import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER  } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

import { AppComponent } from './app.component';
import { IntegrationsComponent } from './components/integrations/integrations.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { FacebookSetupComponent } from './components/setup/facebook-setup/facebook-setup.component';
import { LoginComponent } from './components/login/login.component';
import { TwitterSetupComponent } from './components/setup/twitter-setup/twitter-setup.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppMaterialModule } from './app-material.module';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { INTERCEPTOR_PROVIDERS } from './interceptors';
import { WebhookListComponent } from './components/webhook-list/webhook-list.component';
import { WebhookEditorComponent } from './components/webhook-editor/webhook-editor.component';
import { AppSettingsService } from './services/appsettings.service';
import { RetentionComponent } from './components/retention/retention.component';

export function initConfig(appConfig: AppSettingsService) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,
    IntegrationsComponent,
    PageNotFoundComponent,
    FacebookSetupComponent,
    LoginComponent,
    TwitterSetupComponent,
    ToolbarComponent,
    SidenavComponent,
    WebhookListComponent,
    WebhookEditorComponent,
    RetentionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppMaterialModule,
  ],
  providers: [
    INTERCEPTOR_PROVIDERS,
    AppSettingsService, { provide: APP_INITIALIZER, useFactory: initConfig, deps: [AppSettingsService], multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
